module.exports = __webpack_public_path__ + "static/img/ic_logo@2x.d958086.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_logo@2x.png
// module id = 1CTb
// module chunks = 1